module.exports = __webpack_public_path__ + "img/raju-gaire.4f3442d7.jpg";